import React from "react";
import ReactDOM from "react-dom/client";
import App from "@desktop/App";
import "@desktop/styles/globals.css";
import "./styles/pwa-overrides.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// --- Service worker lifecycle -------------------------------------------------
// Goal: never let an old app shell get pinned by a stale service worker.
//  - dev: unregister everything and register nothing (a dev SW caches the shell
//    and then serves the pre-change UI forever, even across Cmd+R).
//  - prod: autoUpdate registration that reloads when a new SW activates, plus a
//    one-time sweep that strips any leftover/old registration on startup so an
//    already-installed stale SW is removed on the next launch.
if (import.meta.env.DEV) {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.getRegistrations().then((regs) => {
      regs.forEach((reg) => reg.unregister());
    });
  }
} else {
  // Strip any registration that is NOT the controller of this page. The fresh
  // autoUpdate SW (registered just below) becomes the controller, so this only
  // removes orphaned/older shells that were installed by a previous build.
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.getRegistrations().then((regs) => {
      regs
        .filter((reg) => reg.active !== navigator.serviceWorker.controller)
        .forEach((reg) => reg.unregister());
    });
  }

  import("virtual:pwa-register")
    .then(({ registerSW }) => {
      const updateSW = registerSW({
        immediate: true,
        // registerType:"autoUpdate" already calls skipWaiting + clientsClaim in
        // the generated SW. We reload here so the new shell is shown at once
        // instead of on the *next* navigation.
        onNeedRefresh() {
          updateSW(true);
        },
        onRegisteredSW(_swUrl, registration) {
          // If a waiting worker is already sitting there from a prior visit,
          // activate it immediately rather than waiting for all tabs to close.
          registration?.waiting?.postMessage({ type: "SKIP_WAITING" });
        },
      });
    })
    .catch(() => {
      /* PWA virtual module unavailable (e.g. non-PWA build) — ignore. */
    });
}
